module.exports = __webpack_public_path__ + "static/media/br-pb.39171193.svg";